import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import { closeDeleteSmtpModal } from '../../../../actions/modalActions';
import { demoRestriction } from '../../../../helpers/DemoRestriction/demoRestriction';
import { deleteSmtpSetup } from '../../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import Loader from '../../../Loader/Loader';

import bt from '../../../../components/commonStyle.css';
import s from './SmtpModal.css';
import messages from '../../../../locale/jsonMessages';

class DeleteSmtpModal extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { modalShow, closeDeleteSmtpModal, id, handleDelete, deleteLoading } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={modalShow} onHide={closeDeleteSmtpModal} dialogClassName='commonModalContainer globalModalContainer'>
                <Modal.Header closeButton className='commonModalHeader'>
                    <Modal.Title className='commonModalTitle'><FormattedMessage  {...messages.deletingSMTP} /></Modal.Title>
                </Modal.Header>
                <Modal.Body bsClass='commonModalBody'>
                    <p><FormattedMessage  {...messages.areYouSureDeleteWishList} /></p>
                    <div className={s.buttonFlexContainer}>
                        <Button onClick={() => closeDeleteSmtpModal()} className={bt.btnPrimaryBorder}><FormattedMessage  {...messages.cancel} /></Button>
                        <Loader
                            type={"button"}
                            buttonType={"button"}
                            show={deleteLoading}
                            label={formatMessage(messages.confirmDelete)}
                            handleClick={() => { handleDelete(id) }}
                            className={cx(bt.btnPrimary, 'loaderButtonFlex')}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        )
    }

}

const mapState = (state) => ({
    modalShow: state?.modalStatus?.deleteSmtpModal,
    id: state?.modalStatus?.smtpId
});

const mapDispatch = {
    closeDeleteSmtpModal
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DeleteSmtpModal)));
